import React, { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { signOutAccessSession } from '../sessionAccess';

export const TENANT_ACCESS_REJECTED_MESSAGE =
  'This Google account does not have access to this workspace. Try another account or ask a superadmin for access.';

export function isTenantAccessRejection(error) {
  return error?.status === 401 || error?.status === 403;
}

export default function TenantAccessRejected() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [signOutFailed, setSignOutFailed] = useState(false);

  useEffect(() => {
    let active = true;

    const rejectSession = async () => {
      try {
        await signOutAccessSession();
        queryClient.removeQueries({ queryKey: ['currentUserAccess'] });
        queryClient.removeQueries({ queryKey: ['adminAccount'] });
        if (active) {
          navigate('/login', {
            replace: true,
            state: { error: TENANT_ACCESS_REJECTED_MESSAGE },
          });
        }
      } catch (error) {
        console.error('[TenantAccessRejected] Could not clear rejected identity:', error);
        if (active) setSignOutFailed(true);
      }
    };

    rejectSession();
    return () => { active = false; };
  }, [navigate, queryClient]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-900 p-6">
      <section className="max-w-md rounded-xl border border-red-500/30 bg-slate-800 p-6 text-slate-100 shadow-xl">
        <h1 className="text-xl font-semibold">Account not allowed</h1>
        <p role="alert" className="mt-3 text-sm text-slate-300">
          {TENANT_ACCESS_REJECTED_MESSAGE}
        </p>
        {signOutFailed ? (
          <button
            type="button"
            className="mt-5 rounded-lg bg-white px-4 py-2 text-sm font-semibold text-slate-900"
            onClick={() => window.location.reload()}
          >
            Try again
          </button>
        ) : (
          <p role="status" className="mt-4 text-xs text-slate-400">Returning to sign in…</p>
        )}
      </section>
    </main>
  );
}
